import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import {
  AppBar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  IconButton,
  TextField,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";
import jwtDecode from "jwt-decode";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import OAuthService from "src/app/auth/services/oAuthService";

const GroupRowInnerRendererSDP = (props) => {
  const [formOpen, setFormOpen] = useState(false);
  const [formViewOpen, setFormViewOpen] = useState(false);
   const [formEditOpen,setFormEditOpen] = useState(false);
  const [comment, setComment] = useState();
  const [error, setError] = useState();
  const navigate=useNavigate();
  const discountUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}`;
  let hidecomment =
    props?.node?.allLeafChildren[0]?.parent?.childrenAfterAggFilter[0]?.data
      ?.nolteProject?.sdpComment;

  const token =
    localStorage &&
    localStorage.getItem("token") &&
    jwtDecode(localStorage.getItem("token"));

  const handleFormOpen = () => {
    setFormOpen(true);
  };

  const handleViewFormOpen = () => {
    setFormViewOpen(true);
    setComment(
      props?.node?.allLeafChildren[0]?.parent?.childrenAfterAggFilter[0]?.data
        ?.nolteProject?.sdpComment
    );
  };

  const handleViewFormClose = () => {
    setFormViewOpen(false);
  };
  const handleFormClose = () => {
    setFormOpen(false);
  };
  const handleFormEdit = () => {
    setFormEditOpen(true);
    setComment( props?.node?.allLeafChildren[0]?.parent?.childrenAfterAggFilter[0]?.data
        ?.nolteProject?.sdpComment)
  };
 const handleEditFormClose = () => {
    setFormEditOpen(false);
  };
  const handleSubmit = async () => {
    // const model = selectedRows.map((item) => ({
    //     projectNum: [item.id],
    //     comment: Number(item.sdpWg1) || 0,
    //     discountType: Number(item.sdpWg2) || 0,
    // }));
    const model = {
      projectNum: props.value,
      comment: comment,
      discountType: "sdp",
    };

    try {
      await OAuthService.addData(discountUrl + "api/addComment", [model]);
      handleFormClose();
      props.handleSuccessMsg();
      return "SDP discount comment saved successfully";
    } catch (error) {
      setError(error?.response?.data?.errorMessage || error.message);
    }
  };
  const handleOpenOrderDetails = () => {
  const extractedData = props.node.allLeafChildren.map((node) => node.data);

  if (extractedData?.length > 0) {
    const projectId = extractedData[0]?.nolteProject?.project;
    navigate(`/special-discount-details-sdp/${projectId}`, {
      state: { groupOrderDetails: extractedData },
    });
  }
};
  

  return (
    <>
      <span className="flex">
        {props.value}
      {props.value && (token?.scope?.includes("ROLE_IAM") ||
                token?.scope?.includes("ROLE_SOPDIR") ||
                token?.scope?.includes("ROLE_MD") ||
                token?.scope?.includes("ROLE_ADMIN")||
                token?.scope?.includes("ROLE_ORDERPRO")) ? (
                <div className="flex items-center ml-4">
                  
                    <Tooltip title="Open Order Details">
                      <IconButton
                        size={"small"}
                        sx={{ p: "0px 3px" }}
                        onClick={handleOpenOrderDetails}
                      >
                        <FuseSvgIcon
                          size={18}
                          style={{ fill: "#fe9705", marginRight: 4 }}
                        >
                          heroicons-outline:document
                        </FuseSvgIcon>
                      </IconButton>
                    </Tooltip>
                  
                </div>
              ) : null}
      </span>
      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        onClose={handleFormClose}
        open={formOpen}
      >
        <AppBar position="static">
          <Toolbar className="flex w-full justify-between">
            <Typography variant="subtitle1" color="inherit">
              Add Comments:
            </Typography>
            <Button onClick={handleFormClose}>
              <FuseSvgIcon>heroicons-solid:x</FuseSvgIcon>
            </Button>
          </Toolbar>
        </AppBar>

        <DialogContent dividers>
          <Grid container spacing={2} className="mt-2">
            <Grid item xs={4}>
              <label className="min-w-fit">Add SDP Comment :</label>
            </Grid>
            <Grid item xs={8}>
              <TextField
                name="comment"
                value={comment}
                size="small"
                multiline
                rows={4}
                onChange={(e) => {
                  setComment(e.target.value);
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="warning"
            onClick={handleSubmit}
            //   disabled={saveDisabled}
          >
            <FuseSvgIcon>material-solid:save</FuseSvgIcon>
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        onClose={handleViewFormClose}
        open={formViewOpen}
      >
        <AppBar position="static">
          <Toolbar className="flex w-full justify-between">
            <Typography variant="subtitle1" color="inherit">
              View Comments
            </Typography>
            <Button onClick={handleViewFormClose}>
              <FuseSvgIcon>heroicons-solid:x</FuseSvgIcon>
            </Button>
          </Toolbar>
        </AppBar>

        <DialogContent dividers>
          <Grid container spacing={1} className="mt-2">
            <Grid item xs={5}>
              <label className="min-w-fit">SDP comment :</label>
            </Grid>
            <Grid item xs={6}>
              <TextField
                name="comment"
                value={comment}
                size="small"
                onChange={(e) => {
                  setComment(e.target.value);
                }}
                disabled={true}
                multiline
                rows={4}
              />
            </Grid>
          </Grid>
        </DialogContent>
        {/* <DialogActions>
          <Button
            variant="contained"
            color="warning"
            //   onClick={handleSave}
            //   disabled={saveDisabled}
          >
            <FuseSvgIcon>material-solid:save</FuseSvgIcon>
          </Button>
        </DialogActions> */}
      </Dialog>
      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        onClose={handleEditFormClose}
        open={formEditOpen}
      >
        <AppBar position="static">
          <Toolbar className="flex w-full justify-between">
            <Typography variant="subtitle1" color="inherit">
              Edit Comments
            </Typography>
            <Button onClick={handleEditFormClose}>
              <FuseSvgIcon>heroicons-solid:x</FuseSvgIcon>
            </Button>
          </Toolbar>
        </AppBar>

        <DialogContent dividers>
          <Grid container spacing={1} className="mt-2">
            <Grid item xs={5}>
              <label className="min-w-fit">SDP Comment :</label>
            </Grid>
            <Grid item xs={6}>
              <TextField
                name="comment"
                value={comment}
                size="small"
                multiline
                rows={4}
                onChange={(e) => {
                  setComment(e.target.value);
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="warning"
            onClick={handleSubmit}
            //   disabled={saveDisabled}
          >
            <FuseSvgIcon>material-solid:save</FuseSvgIcon>
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default GroupRowInnerRendererSDP;
